import { fromJS, Map } from 'immutable';

const NAME_SPACE = 'LEGDER/ARS/';

const initialState = new Map({
  'loading': true,
  'ledger_title_list': [],
  'ledger': {
    'data': [],
    'pageSize': 0,
    'currentPage': 0,
    'count': 0,
  }
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'SWAP_RIGHT':
      return state.update('ledger', (ledger) => {
        return ledger.update('data', (data) => {
          return data.update(action.payload.index, item => {
            const _item = Object.assign({}, item.toJS());
            const data = JSON.parse(_item.orther);
            data.originalOrdersData.groups_no = item.get('groups_no');
            data.originalOrdersData.price = item.get('price');
            data.originalOrdersData.num = item.get('num');
            _item.is_merge = 1;
            _item.is_correct = 1;
            _item.orther = JSON.stringify(data);
            return fromJS(_item);
          });
        });
      });
    case NAME_SPACE + 'IS_MERGE':
      return state.update('ledger', (ledger) => {
        return ledger.update('data', (data) => {
          return data.update(action.payload.index, item => {
            return item.merge({ 'is_merge': 1 });
          });
        });
      });
    case NAME_SPACE + 'EDIT':
      return state.update('ledger', (ledger) => {
        return ledger.update('data', (data) => {
          return data.update(action.payload.index, item => {
            const _item = Object.assign({}, item.toJS());
            const data = JSON.parse(_item.orther);
            data.originalOrdersData[action.payload.k] = action.payload.v || 0;
            const ood = data.originalOrdersData;
            /*
            console.log(
              ood.groups_no === item.get('groups_no'), ood.groups_no, item.get('groups_no'), '|',
              ood.price === item.get('price'), ood.price, item.get('price'), '|',
              ood.num === item.get('num'), ood.num, item.get('num'), '|',
            );
            */
            // ood.groups_no === item.get('groups_no') && 
            if (parseFloat(ood.price) === parseFloat(item.get('price')) && parseInt(ood.num, 10) === parseInt(item.get('num'), 10)) {
              _item.is_merge = 1;
              _item.is_correct = 1;
            } else {
              _item.is_merge = 0;
              _item.is_correct = 0;
            }
            _item.orther = JSON.stringify(data);
            return fromJS(_item);
          });
        });
      });
    case NAME_SPACE + 'RECEIVE_ARS_COLLECTION':
      return fromJS(action.payload.Collection);
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'SWAP_RIGHT':
      return item(state, action);
    case NAME_SPACE + 'IS_MERGE':
      return item(state, action);
    case NAME_SPACE + 'EDIT':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_ARS_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};